<template>
  <l-rows>
    <a-title :text="this.$t('common.versions')" />
    <l-columns space="between">
      <game-select
        @input="handleGameSelect"
      />
      <l-columns-column class="bottom">
        <a-button
          variant="primary"
          :text="this.$t('versions.add')"
          @click="handleAdd"
        />
      </l-columns-column>
    </l-columns>
    <back-office-list
      class="has-word-break-all"
      :loading="versionsMeta.loading"
      :list-data="versions"
      :columns="columns"
      :selection-change="handleSelectionChange"
    />
  </l-rows>
</template>

<script>
  import { AButton, ATitle, LColumns, LColumnsColumn, LRows } from 'codefabrik-gui-vue'
  import BackOfficeList from '@/components/BackOfficeList'
  import { useGameVersions } from '@/views/games/gameHooks'
  import GameSelect from '@/components/GameSelect'
  import { mapActions, mapState } from 'vuex'
  import { JurisdictionsColumn } from "@/components";

  export default {
    name: 'GamesVersionList',
    components: { GameSelect, BackOfficeList, AButton, ATitle, LRows, LColumns, LColumnsColumn },
    data () {
      return {
        versions: [],
      }
    },
    mixins: [
      useGameVersions('versions', 'selectedGameId')
    ],
    computed: {
      ...mapState('game', ['selectedGameId']),
      columns () {
        return [
          {
            header: this.$t('common.version'),
            size: '2',
            field: 'version',
          },
          {
            header: this.$t('versions.frontendUrl'),
            field: 'frontendUrl',
          },
          {
            header: this.$t('versions.backendUrl'),
            field: 'backendUrl',
          },
          {
            header: this.$t('versions.historyUrl'),
            field: 'historyUrl',
          },
          {
            size: '2',
            component: JurisdictionsColumn,
            componentProperties: {
              jurisdictions: it => it.jurisdictions,
            },
            header: this.$t('versions.jurisdictions'),
            contentPosition: 'left'
          },
          {
            header: this.$t('versions.betSizes'),
            field: 'betSizes',
          },
          {
            size: '1',
            contentPosition: 'right',
            component: AButton,
            componentProperties: {
              text: "",
              iconLeft: 'fas fa-copy',
              variant: 'primary'
            },
            componentListeners: {
              click: this.handleCopy
            }
          }
        ]
      },
    },
    methods: {
      ...mapActions('game', ['setGameId']),
      handleGameSelect (value) {
        this.setGameId(value)
        if (this.selectedGameId === null || this.selectedGameId === '') {
          this.versions = []
        }
      },
      handleAdd () {
        this.$router.push({ name: 'add-version' })
      },
      handleSelectionChange (version) {
        this.$router.push({ name: 'edit-version', params: { id: version.id } })
      },
      handleCopy (version) {
        this.$router.push({ name: 'copy-version', params: { id: version.id } })
      }
    },
  }
</script>

<style
  lang="scss"
  scoped
>
  .bottom {
    margin-top: auto;
  }

  .has-word-break-all {
    word-break: break-all;
  }
</style>
